var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFire3A(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -0.5 12 12",
    shapeRendering: "crispEdges",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#af0800",
    d: "M5 2h1M5 3h1M5 4h2M4 5h1m2 0h1M3 6h2m2 0h1M3 7h1m4 0h1M3 8h1m4 0h1M4 9h1m2 0h1m-3 1h2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#f21c00",
    d: "M5 5h2M6 6h1M4 7h1m2 0h1M4 8h1m2 0h1M5 9h2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#ff4c00",
    d: "M5 6h1m0 1h1M5 8h2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#ff8300",
    d: "M5 7h1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFire3A);
export default __webpack_public_path__ + "static/media/fire3a.cb6836d913a924754efa4d54a095cd8b.svg";
export { ForwardRef as ReactComponent };